import clsx from "classnames";
import { useStyles } from "./ServiceSelection.style";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { ServiceSelectionItem } from "./ServiceSelectionItem";
import { servicesList } from "../../../constants/services";
import {
  setIsShowService,
  triggerDelayWithTimeout,
} from "../../../store/slices/popup";
import AppBar from "../AppBar/AppBar";
import { Icon } from "../../core/Icon/Icon";
import { PageRoutes } from "../../../constants/historyGaming";
import { useNavigate } from "react-router-dom";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";

const ServiceSelection: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement>
> = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { isShowService, isPopupDelayActive } = useAppSelector(
    (state) => state.popup,
  );

  const onCloseServicePopup = () => {
    dispatch(triggerDelayWithTimeout(300));
    dispatch(setIsShowService({ isShowService: false }));
  };

  const onClickService = (title: string) => {
    if (window.location.pathname !== PageRoutes.HomePage) {
      navigate(`${PageRoutes.HomePage}?service=${title}`);
    } else {
      document.getElementById(`service-${title}`)?.scrollIntoView({
        behavior: "smooth",
      });
    }
    dispatch(setIsShowService({ isShowService: false }));
  };

  if (!isShowService && !isPopupDelayActive) return null;

  return (
    <div
      className={clsx(
        classes.root,
        isShowService ? classes.forwardsAnimate : classes.backwardsAnimate,
      )}
    >
      <AppBar
        leftItems={
          <Icon
            className={classes.icon}
            name="icon-bold-close"
            onClick={() => onCloseServicePopup()}
            data-testid="settings-icon"
          />
        }
        centerItems={
          <Typography variant={TypographyVariant.BodyB4Medium}>Menu</Typography>
        }
      />
      <div className={classes.service}>
        {servicesList.map((item, key) => {
          if (item.id === "mySubscriptions") return null;
          return (
            <ServiceSelectionItem
              launchpads={item.launchpads}
              title={item.title}
              key={key}
              onClick={() => onClickService(item.title)}
              data-testid="service-app-icon"
            />
          );
        })}
      </div>
    </div>
  );
};

export default ServiceSelection;
